// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__-_g2R"};